// IRev Extraction (monitoring + retry of the external-iRev extraction pipeline).
// Mirror backend api.core/Authorization/ActionKeys.cs — keep literals in sync (see the
// backend follow-up note: these keys must be seeded + granted server-side for the role to
// actually allow access; frontend gating only reads the local set).
export const ACTIONS_IREV_EXTRACTION = {
	IREV_EXTRACTION: 'irev_extraction',
	IREV_EXTRACTION_VIEW: 'irev_extraction_view',
	/** Gate for the single-row + bulk retry actions. */
	IREV_EXTRACTION_RETRY: 'irev_extraction_retry',
} as const;
